import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HostProjectsCrumb(props: Partial<BreadcrumbData>) {
  return <Breadcrumb name="Deployments" {...props} />;
}
